// Data Management — sandbox create/reset tools.
// Moved out of Settings.jsx (iter265) so it can live in the Integrations tab.
import { useState } from "react";
import { Database } from "lucide-react";
import { PanelHeader } from "@/components/settings/SettingsUI";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { createSandbox, resetSandbox } from "@/lib/api";

export default function DataManagementPanel() {
  const [resetting, setResetting] = useState(false);
  const [creating, setCreating] = useState(false);

  const handleResetSandbox = async () => {
    setResetting(true);
    try {
      await resetSandbox();
      toast.success("Sandbox reset to fresh state");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to reset sandbox");
    } finally { setResetting(false); }
  };

  const handleCreateSandbox = async () => {
    setCreating(true);
    try {
      await createSandbox();
      toast.success("Sandbox Test Project created");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to create sandbox");
    } finally { setCreating(false); }
  };

  return (
    <div>
      <PanelHeader icon={Database} title="Data Management" hint="Sandbox reset tools" testId="toggle-data-management" />
      {true && (
        <div className="px-5 py-4 space-y-5">

          {/* Sandbox Controls — the destructive "Wipe All Data" button was
              removed entirely per PM direction. Reset Sandbox is the safe
              alternative: it only touches records tagged as sandbox test
              data, so live customer records are untouched even in prod. */}
          <div className="border rounded-lg p-4 bg-blue-50/50 space-y-3">
            <h4 className="font-semibold text-sm text-slate-800">Sandbox Test Project</h4>
            <p className="text-xs text-slate-500">
              A dedicated test client with sample data (lead, proposal, WO, invoice, equipment).
              Use it to test every feature without affecting real data. Reset anytime.
            </p>
            <div className="flex gap-2">
              <Button size="sm" variant="outline" onClick={handleCreateSandbox} disabled={creating} data-testid="btn-create-sandbox">
                {creating ? "Creating..." : "Create Sandbox"}
              </Button>
              <Button size="sm" variant="outline" className="border-blue-300 text-blue-700 hover:bg-blue-100" onClick={handleResetSandbox} disabled={resetting} data-testid="btn-reset-sandbox">
                {resetting ? "Resetting..." : "Reset Sandbox"}
              </Button>
            </div>
          </div>

        </div>
      )}
    </div>
  );
}
